import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import MarqueeStrip from "@/components/MarqueeStrip";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import PromoBanner from "@/components/PromoBanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [bannerOpen, setBannerOpen] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.lenis;
    };
  }, []);

  return (
    <div className="App grain bg-[#EFD9AE] text-[#241B2E] selection:bg-[#C1440E]" data-testid="app-root">
      {bannerOpen && <PromoBanner onClose={() => setBannerOpen(false)} />}
      <Navbar offset={bannerOpen} />
      <main>
        <Hero />
        <Services />
        <Manifesto />
        <Gallery />
        <MarqueeStrip />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
